<template>
  <BaseWrapper :loading="loading">
    <div class="space-y-4">
      <BaseCard title="Tambah Saldo Stockist">
        <div class="grid grid-cols-6 gap-4">
          <div class="col-span-full">
            <BaseInput
              label="Tanggal"
              inset
              disabled
              type="date"
              v-model="form.date"
            />
          </div>
          <div class="col-span-3">
            <SearchOfficeInput office-type="stockist" v-model="form.stockist" />
          </div>
          <div class="col-span-3">
            <BaseInput
              label="Nama Stockist"
              inset
              disabled
              placeholder="Andi"
              v-model="form.stockist.name"
            />
          </div>
          <div class="col-span-2">
            <BaseInput label="Tipe Topup" inset>
              <BaseSelect
                inset
                expand
                :options="[
                  { key: 'null', label: 'Pilih Tipe Topup', value: null },
                  { key: 'bonus', label: 'Bonus', value: 'bonus' },
                  { key: 'pinjaman', label: 'Pinjaman', value: 'pinjaman' },
                  { key: 'lainnya', label: 'Lainnya', value: 'lainnya' },
                ]"
                v-model="form.type"
              />
            </BaseInput>
          </div>
          <div class="col-span-2">
            <BaseInput
              label="Keterangan"
              inset
              placeholder="Lainnya"
              type="text"
              v-model="form.description"
            />
          </div>
          <div class="col-span-2">
            <BaseInput
              label="Nominal Topup"
              inset
              placeholder="0"
              type="text"
              currency
              v-model="form.amount"
            />
          </div>
        </div>
      </BaseCard>

      <div class="flex justify-end gap-2">
        <BaseButton
          :disabled="!form.stockist.id || !form.type || !form.amount"
          @click="visibleConfirm = true"
          >Simpan</BaseButton
        >
        <BaseButton color="white" :to="{ name: 'topup.saldo-stockist' }"
          >Kembali</BaseButton
        >
      </div>
    </div>

    <BaseConfirm
      icon-type="badge"
      type="success"
      title="Konfirmasi Topup Saldo Stockist"
      confirm-text="Konfirmasi"
      :visible="visibleConfirm"
      @close="visibleConfirm = false"
      @confirmed="onSubmit"
    >
      <template #message>
        <p class="text-gray-500">Tekan tombol konfirmasi untuk mengonfirmasi topup saldo stockist <strong class="text-gray-900">{{ form.stockist.code }}</strong> dengan nominal <strong class="text-gray-900">{{ form.amount | toCurrency }}.</strong></p>
      </template>
    </BaseConfirm>
  </BaseWrapper>
</template>

<script>
import { mapActions } from 'vuex';
import BaseConfirm from '../../../../../components/base/BaseConfirm.vue';
import SearchOfficeInput from '../../../../../components/office/search-office-input.vue';
import { requestMixin } from '../../../../../mixins/request/request';

export default {
  mixins: [requestMixin],
  components: {
    SearchOfficeInput,
    BaseConfirm,
  },
  data() {
    return {
      loading: false,
      form: {
        date: new Date(),
        stockist: {
          id: null,
          code: null,
          searchCode: null,
          originalCode: null,
          name: null,
        },
        type: null,
        description: null,
        amount: null,
      },
      visibleConfirm: false,
    };
  },
  methods: {
    ...mapActions({
      createAlert: 'alert/createAlert',
    }),
    async onSubmit() {
      this.loading = true;

      const [, err] = await this.request(
        `/api/v1/offices/${this.form.stockist.id}/-actions/top-up-stockist`,
        {
          method: 'post',
          data: {
            type: this.form.type,
            description: this.form.description,
            amount: this.form.amount
              ? this.form.amount.replace(/\D/gi, '')
              : null,
          },
        }
      );

      if (err) {
        this.createAlert({
          status: 'error',
          data: this.getRequestErrorMessage(err),
        });
      } else {
        this.createAlert({
          status: 'success',
          data: 'Berhasil topup saldo stockist',
        });

        this.$router.push({ name: 'topup.saldo-stockist' });
      }

      this.loading = false;
    },
  },
};
</script>
